import React, { useState } from 'react';
import { Info, Heart, Shield, AlertCircle } from 'lucide-react';

const Welcome = ({ formData, updateFormData, t }) => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  return (
    <div className="space-y-8 animate-fade-in">
      {/* Hero Section */}
      <div className="text-center space-y-4">
        <div className="inline-block p-4 bg-gradient-to-br from-blue-500 to-blue-600 rounded-3xl shadow-lg">
          <Heart size={48} className="text-white" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900">
          {t?.welcomeTitle || 'Bienvenue sur HEAREN'}
        </h1>
        
        <p className="text-lg text-gray-600 max-w-md mx-auto">
          {t?.welcomeMessage || 'Personnalisez votre expérience en quelques questions simples'}
        </p>
      </div>

      {/* Benefits */}
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl p-6 space-y-4">
        <h3 className="font-semibold text-gray-900 flex items-center gap-2">
          <span className="text-blue-500">✨</span>
          {t?.whatYouWillGet || 'Ce que vous allez obtenir'}
        </h3>
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-white text-xs font-bold">1</span>
            </div>
            <span className="text-gray-700">
              {t?.benefit1 || 'Des sons apaisants adaptés à vos besoins'}
            </span>
          </li>
          <li className="flex items-start gap-3">
            <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-white text-xs font-bold">2</span>
            </div>
            <span className="text-gray-700">
              {t?.benefit2 || 'Un parcours personnalisé selon votre profil'}
            </span>
          </li>
          <li className="flex items-start gap-3">
            <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-white text-xs font-bold">3</span>
            </div>
            <span className="text-gray-700">
              {t?.benefit3 || 'Des recommandations ciblées pour votre bien-être'}
            </span>
          </li>
        </ul>
      </div>

      {/* Consent Section */}
      <div className="space-y-4">
        <h3 className="font-semibold text-gray-900 flex items-center gap-2">
          <Shield size={20} className="text-blue-500" />
          {t?.importantInformation || 'Information importante'}
        </h3>
        
        {/* Consent Checkbox */}
        <label className="flex items-start gap-3 p-4 border-2 rounded-2xl cursor-pointer transition-all hover:border-blue-300 bg-white">
          <input
            type="checkbox"
            checked={formData.consent_non_medical}
            onChange={(e) => updateFormData({ consent_non_medical: e.target.checked })}
            className="mt-1 w-5 h-5 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
          />
          <div className="flex-1">
            <p className="text-sm text-gray-700 leading-relaxed">
              {t?.consentText || "Je comprends qu'HEAREN est une application de bien-être et d'éducation sonore, pas un dispositif médical."}
            </p>
          </div>
        </label>

        {/* Learn More Button */}
        <button
          onClick={() => setShowDisclaimer(!showDisclaimer)}
          className="flex items-center gap-2 text-sm text-blue-500 hover:text-blue-600 font-medium"
        >
          <Info size={16} />
          {t?.learnMore || 'En savoir plus'}
        </button>

        {/* Disclaimer Modal */}
        {showDisclaimer && (
          <div className="p-6 bg-yellow-50 border border-yellow-200 rounded-2xl space-y-3">
            <h4 className="font-semibold text-gray-900 flex items-center gap-2">
              <AlertCircle className="text-yellow-600" size={20} />
              {t?.importantWarning || 'Avertissement important'}
            </h4>
            <p className="text-sm text-gray-700 leading-relaxed">
              {t?.disclaimerText || "HEAREN est une application de bien-être et d'éducation sonore. Elle ne remplace pas un avis médical. En cas de symptômes nouveaux, violents, ou d'acouphènes pulsatiles, consultez un professionnel de santé."}
            </p>
            <button
              onClick={() => setShowDisclaimer(false)}
              className="text-sm text-blue-500 hover:text-blue-600 font-medium"
            >
              {t?.close || 'Fermer'}
            </button>
          </div>
        )}
      </div>

      {/* Time Indicator */}
      <div className="text-center pt-4">
        <p className="text-sm text-gray-500">
          {t?.timeEstimate || '⏱️ Moins de 2 minutes pour personnaliser votre expérience'}
        </p>
      </div>
    </div>
  );
};

export default Welcome;
